import { mapState } from "vuex";
import PaymentOption from "../components/payment/PaymentOption.vue";
import Currency from "./../components/Currency.vue";
import Connection from "@/modules/checkin-facility/pages/dashboard/components/Connection.vue";

export default {
  components: {
    PaymentOption,
    Currency,
    Connection
  },
  data() {
    return {
      navs: {
        paymentOption: 1,
        currency: 0,
        connection: 0,
      },
    };
  },
  computed: {
    ...mapState("checkin-facility", ["facility"]),
  },
  async mounted() {
    if (!this.facility.has_pms)
      return this.$router.push({
        name: "checkin-facility-dashboard-home",
      });
  },
  methods: {
    selectTab(name) {
      Object.keys(this.navs).map((obj) => (this.navs[obj] = 0));
      this.navs[name] = 1;
    },
  },
};
